import { render, staticRenderFns } from "./DepartmentSlidebar.vue?vue&type=template&id=be6a704a"
import script from "./DepartmentSlidebar.vue?vue&type=script&lang=js"
export * from "./DepartmentSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports